if ( typeof MainHeader !== 'function' ) {

	class MainHeader extends HTMLElement {

		constructor(){
			super();
			this.#mount();
		}

		#mount(){

			/* -- > DRAWERS < -- */

			// Sticky header

			if ( this.hasAttribute('data-sticky-header') ) {

				const stickyHeader = document.createElement('div');
				stickyHeader.classList = 'sticky-header'
				stickyHeader.setAttribute('data-js-inert', '');
				stickyHeader.innerHTML = `<div class="site-header header__top container--large">
					${this.querySelector('.header__top').innerHTML}
				</div>`;
				document.body.append(stickyHeader);
				this._stickyHeaderEl = stickyHeader;

				const stickyHeaderDeskBound = this.querySelector('.header-container--bottom');
				const stickyHeaderMobileBound = this.querySelector('.header__top');
				const stickyHeaderDeskPlaceholder = document.createElement('div');
				stickyHeaderDeskPlaceholder.classList.add('sticky-header__desktop-placeholder', 'portable-hide');
				stickyHeaderDeskPlaceholder.setAttribute('aria-hidden', 'true');

				const mountDesktopHeader = () => {
					if ( window.innerWidth < 1024 || stickyHeaderDeskBound.parentElement === stickyHeader ) return;
					stickyHeaderDeskPlaceholder.style.height = `${stickyHeaderDeskBound.offsetHeight}px`;
					stickyHeaderDeskBound.before(stickyHeaderDeskPlaceholder);
					stickyHeader.prepend(stickyHeaderDeskBound);
				};

				const restoreDesktopHeader = () => {
					if ( stickyHeaderDeskBound.parentElement !== stickyHeader ) return;
					stickyHeaderDeskPlaceholder.replaceWith(stickyHeaderDeskBound);
				};

				const showStickyHeader = () => {
					mountDesktopHeader();
					stickyHeader.classList.add('show');
				};

				const hideStickyHeader = () => {
					stickyHeader.classList.remove('show');
					restoreDesktopHeader();
				};

				this._restoreDesktopHeader = restoreDesktopHeader;

				if ( this.querySelector('.button--cart-handle') && stickyHeader.querySelector('.header-actions') ) {
					stickyHeader.querySelector('.header-actions').append(this.querySelector('.button--cart-handle').cloneNode(true));
				}

				stickyHeader.querySelectorAll('[id]').forEach(elm=>{
					elm.id = `${elm.id}-sticky`;
				})
				stickyHeader.querySelectorAll('[aria-controls]').forEach(elm=>{
					if ( ! ( elm.hasAttribute('data-js-sidebar-handle') || elm.hasAttribute('data-modal') ) ) {
						elm.setAttribute('aria-controls', `${elm.getAttribute('aria-controls')}-sticky`);
					}
				})

				window.lst = window.scrollY;
				window.lhp = 0;

				const stickyHeaderMayRemoveShowOnScrollDown = ()=>{
					return ! this._headerMobileSearchExpanded;
				};

				this.SCROLL_StickyHelper = () =>{
					
					var st = window.scrollY;
					try {
						const desktopBound = stickyHeaderDeskPlaceholder.isConnected ? stickyHeaderDeskPlaceholder : stickyHeaderDeskBound;
						if ( ( st <= 0 || ( window.innerWidth >= 1024 ? desktopBound.getBoundingClientRect().top >= 0 : stickyHeaderMobileBound.getBoundingClientRect().top >= 0 ) ) && stickyHeader.classList.contains('show') ) {
							hideStickyHeader();
							return;
						}

						if ( st < 0 || Math.abs(lst - st) <= 5 )
							return;	

						if ( st > window.lhp ) {

							if ( st === 0 && stickyHeader.classList.contains('show') ) {

								hideStickyHeader();

							} else if ( st <= lst && ! stickyHeader.classList.contains('show') ) {

								window.lhp = stickyHeader.offsetTop;
								if ( ( window.innerWidth >= 1024 ? desktopBound.getBoundingClientRect().top : stickyHeaderMobileBound.getBoundingClientRect().top ) < -100 ) {
									showStickyHeader();
								}

							} else if ( st > lst && stickyHeader.classList.contains('show') ) {
								if ( stickyHeaderMayRemoveShowOnScrollDown() ) {
									hideStickyHeader();
								}
							}

						}
					} finally {
						window.lst = st;
					}

				}

				window.addEventListener('scroll', this.SCROLL_StickyHelper, {passive:true});
				this.RESIZE_StickyHelper = () => {
					if ( ! stickyHeader.classList.contains('show') || window.innerWidth < 1024 ) {
						restoreDesktopHeader();
					} else {
						mountDesktopHeader();
					}
				};
				window.addEventListener('resize', this.RESIZE_StickyHelper, {passive:true});

					stickyHeaderDeskBound.querySelectorAll('.submenu-masonry').forEach(elm=>{
						let columns = 4;
						if ( elm.classList.contains('with-2-promotions') ) {
							columns = 2;
						} else if ( elm.classList.contains('with-promotion') ) {
							columns = 3;
						}
						if ( elm.dataset.columns ) {
							columns = parseInt(elm.dataset.columns);
						}
						const trigger = elm.closest('.has-submenu');
						if ( ! trigger ) return;
						// Build MiniMasonry on first open (relayout on later opens) inside rAF, once
						// the menu is visible — measuring a hidden menu produced inconsistent gaps.
						let masonry = null;
						const layoutMasonry = () => requestAnimationFrame(() => {
							if ( ! elm.closest('.site-nav')?.classList.contains('style--classic') ) return;
							if ( typeof MiniMasonry === 'undefined' ) return;
							const width = elm.clientWidth;
							if ( ! width ) return;
							if ( masonry ) masonry.destroy();
							elm.classList.add('masonry-active');
							masonry = new MiniMasonry({
								container: elm,
								baseWidth: Math.floor(width / columns),
								gutter: 0,
								surroundingGutter: false,
								direction: document.documentElement.getAttribute('dir') === 'rtl' ? 'rtl' : 'ltr'
							});
							elm.querySelectorAll('img').forEach(img => {
								if ( ! img.complete ) {
									img.addEventListener('load', () => { if ( masonry ) masonry.layout(); }, { once: true });
								}
							});
						});
						trigger.addEventListener('mouseenter', layoutMasonry);
						trigger.addEventListener('focusin', layoutMasonry);
					});
				
			} else {
				this._stickyHeaderEl = null;
			}

			// drawer cart connections

			document.querySelectorAll('[data-js-sidebar-handle]').forEach(elm => {
				if ( elm.hasAttribute('aria-controls') ) {
					const elmSidebar = document.getElementById(elm.getAttribute('aria-controls'));
					elm.addEventListener('click', e=>{
						e.preventDefault();
						elm.setAttribute('aria-expanded', 'true');
						elmSidebar.show();
					})
					elm.addEventListener('keyup', e=>{
						if ( e.keyCode === window.KEYCODES.RETURN ) {
							elm.setAttribute('aria-expanded', 'true');
							elmSidebar.show();
							window.lastFocusedElm = elm;
							elmSidebar.querySelector('[data-js-close]').focus();
						}
					})
				}
			})
			
			// closing drawers

			document.querySelectorAll('sidebar-drawer [data-js-close]').forEach(elm=>{
				elm.addEventListener('keydown', e=>{
					if ( e.keyCode === window.KEYCODES.RETURN ) {
						if ( window.lastFocusedElm ) {
							setTimeout(()=>{
								window.lastFocusedElm.focus();
								window.lastFocusedElm = null;
							}, 100);
						}
					}
				});
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( e.target.closest('.sidebar').classList.contains('sidebar--opened') ) {
						e.target.closest('.sidebar').hide();
					}
				});
			});
			document.querySelector('.site-overlay').addEventListener('click', ()=>{
				if ( document.querySelector('.sidebar--opened') ) {
					document.querySelector('.sidebar--opened').hide();
				}
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode === window.KEYCODES.ESC ) {
					if ( document.querySelector('.sidebar--opened') ) {
						document.querySelector('.sidebar--opened').hide();
						if ( window.lastFocusedElm ) {
							window.lastFocusedElm.focus();
							window.lastFocusedElm = null;
						}
					}
				}
			});

			// resizing drawers

			const rootHeight = document.getElementById('root-height');
			this.RESIZE_SidebarHelper = debounce(()=>{
				rootHeight.innerHTML = `:root {
					--window-height: ${window.innerHeight}px;
				}`;
			}, 200);
			window.addEventListener('resize', this.RESIZE_SidebarHelper);
			rootHeight.innerHTML = `:root {
				--window-height: ${window.innerHeight}px;
			}`;

			// Inert elements

			document.querySelectorAll('#main > div').forEach(elm=>{
				if ( ! elm.classList.contains('inert-inside') ) {
					elm.setAttribute('data-js-inert', '');
				}
			})
			window.inertElems = document.querySelectorAll('[data-js-inert]');

			// Init modal windows

			document.querySelectorAll('[aria-controls="modal-store-selector"]').forEach(elm=>{
				elm.addEventListener('keydown', e=>{
					if ( e.keyCode === window.KEYCODES.RETURN ) {
						window.lastFocusedElm = elm;
					}
				})
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( document.querySelector('.sidebar--opened') ) {
						document.querySelector('.sidebar--opened').hide();
					}
					if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
						document.getElementById(elm.getAttribute('aria-controls')).show();
					}
				})
				elm.addEventListener('keyup', e=>{
					if ( e.keyCode === window.KEYCODES.RETURN ) {
						if ( document.querySelector('.sidebar--opened') ) {
							document.querySelector('.sidebar--opened').hide();
						}
						if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
							document.getElementById(elm.getAttribute('aria-controls')).show();
						}
					}
				})
			});

			// Submenu alignment

			const rtl = document.documentElement.getAttribute('dir') === 'rtl';
			document.querySelectorAll('.site-nav.style--classic .has-submenu').forEach(elm=>{
				elm.addEventListener('mouseover', ()=>{
					if ( elm.querySelector('.normal-menu') ) {
						elm.querySelector('.normal-menu').style.left = `${rtl ? elm.getBoundingClientRect().right : elm.getBoundingClientRect().left}px`;
					}
				})
			});

			// predictive search

			const bindPredictiveSearchInputListeners = elm=>{
				if ( ! elm ) {
					return;
				}
				elm.addEventListener('focus', ()=>{
					const overlay = document.getElementById(elm.dataset.jsFocusOverlay);
					if ( overlay ) {
						overlay.classList.add('active');
					}
					if ( ! document.body.classList.contains('predictive-script-loaded') ) {
						document.body.classList.add('predictive-script-loaded')
						const predictiveSearchJS = document.createElement('script');
						predictiveSearchJS.src = KROWN.settings.predictive_search_script;
						document.head.appendChild(predictiveSearchJS); 
					}
				})
				elm.addEventListener('keydown', e=>{
					if ( e.keyCode === window.KEYCODES.TAB ) {
						const desktopOverlay = document.getElementById('search-results-overlay-desktop');
						if ( desktopOverlay && desktopOverlay.classList.contains('active') ) {
							desktopOverlay.classList.remove('active');
						}
					}
				})
			};

			if ( JSON.parse(document.getElementById('shopify-features').text).predictiveSearch ) {
				document.querySelectorAll('search-form [data-js-search-input]').forEach(bindPredictiveSearchInputListeners)
				window.addEventListener('load', ()=>{
					document.querySelectorAll('.search-results-overlay').forEach(elm=>{
						elm.style = '';
					})
				});
			} else {
				document.querySelector('search-form [data-js-search-input] + button').classList.add('button--invisibile-trigger');
			}

			// mobile search: reveal on first click, focus on every click (independent per header)

			const mobileSearchSource = this.querySelector('[data-header-mobile-search-panel]');
			const mobileSearchToggles = document.querySelectorAll('[data-header-mobile-search-toggle]');
			this._headerMobileSearchExpanded = false;
			if ( mobileSearchSource && mobileSearchToggles.length ) {

				let mainRevealed = false;
				let stickyRevealed = false;

				const revealMainSearch = ()=>{
					if ( mainRevealed ) {
						return;
					}
					mainRevealed = true;
					this._headerMobileSearchExpanded = true;
					mobileSearchSource.classList.remove('hide');
				};

				const revealStickySearch = ()=>{
					if ( stickyRevealed || ! this._stickyHeaderEl ) {
						return;
					}
					stickyRevealed = true;
					this._headerMobileSearchExpanded = true;
					const clone = mobileSearchSource.cloneNode(true);
					clone.classList.remove('hide');
					clone.setAttribute('data-header-mobile-search-clone', '');
					this._stickyHeaderEl.appendChild(clone);
					clone.querySelectorAll('[id]').forEach(elm=>{
						elm.id = `${elm.id}-sticky`;
					});
					clone.querySelectorAll('[data-js-focus-overlay]').forEach(elm=>{
						const ref = elm.getAttribute('data-js-focus-overlay');
						if ( ref ) {
							elm.setAttribute('data-js-focus-overlay', `${ref}-sticky`);
						}
					});
					if ( JSON.parse(document.getElementById('shopify-features').text).predictiveSearch ) {
						bindPredictiveSearchInputListeners(clone.querySelector('[data-js-search-input]'));
					}
				};

				mobileSearchToggles.forEach(btn=>{
					btn.addEventListener('click', e=>{
						e.preventDefault();
						const fromSticky = this._stickyHeaderEl && btn.closest('.sticky-header');
						if ( fromSticky ) {
							revealStickySearch();
							const input = this._stickyHeaderEl.querySelector('[data-header-mobile-search-panel] input[type=search]');
							if ( input ) {
								input.focus();
							}
						} else {
							revealMainSearch();
							const input = mobileSearchSource.querySelector('input[type=search]');
							if ( input ) {
								input.focus();
							}
						}
						btn.setAttribute('aria-expanded', 'true');
					});
				});
			}

			this._headerSearchQNameSync = e=>{
				if ( e.target.tagName !== 'INPUT' || e.target.name !== 'q' ) {
					return;
				}
				if ( ! e.target.closest('#site-header') && ! e.target.closest('.sticky-header') ) {
					return;
				}
				const enterCode = window.KEYCODES ? window.KEYCODES.RETURN : 13;
				const enterInit = { key: 'Enter', code: 'Enter', keyCode: enterCode, which: enterCode, bubbles: true, cancelable: true };
				document.querySelectorAll('#site-header input[name="q"], .sticky-header input[name="q"]').forEach(el=>{
					if ( el !== e.target ) {
						el.value = '';
						el.dispatchEvent(new KeyboardEvent('keydown', enterInit));
						el.dispatchEvent(new KeyboardEvent('keyup', enterInit));
					}
				});
			};
			document.body.addEventListener('input', this._headerSearchQNameSync);

			// touch navigation for the menu

			const closeTouchSubmenus = (focusedElm, focusedParent=null)=>{
				document.querySelectorAll('.style--classic li.focus').forEach(elm=>{
					if ( ! ( elm === focusedElm || elm === focusedParent ) ) {
						elm.classList.remove('focus');
						elm.querySelector(':scope > .menu-link')?.setAttribute('aria-expanded', 'false');
					}
				})
			}
			document.querySelectorAll('.style--classic .has-babymenu').forEach(elm=>{
				const trigger = elm.querySelector(':scope > .menu-link');
				const toggle = trigger?.querySelector(':scope > .icon');
				if ( ! trigger || ! toggle || ! elm.querySelector(':scope > .babymenu a[href]') ) return;
				toggle.addEventListener('touchstart', e=>{
					if ( ! elm.closest('.site-nav')?.classList.contains('style--classic') ) return;
					e.preventDefault();
					e.stopPropagation();
					elm.classList.toggle('focus');
					trigger.setAttribute('aria-expanded', elm.classList.contains('focus') ? 'true' : 'false');
					closeTouchSubmenus(elm,elm.closest('.has-submenu'));
				}, { passive:false });
			})
			document.querySelectorAll('.style--classic .has-submenu').forEach(elm=>{
				if ( ! elm.classList.contains('mega-link') ) {
					const trigger = elm.querySelector(':scope > .menu-link');
					const toggle = trigger?.querySelector(':scope > .icon');
					if ( ! trigger || ! toggle || ! elm.querySelector(':scope > .submenu a[href]') ) return;
					toggle.addEventListener('touchstart', e=>{
						if ( ! elm.closest('.site-nav')?.classList.contains('style--classic') ) return;
						e.preventDefault();
						e.stopPropagation();
						elm.classList.toggle('focus');
						trigger.setAttribute('aria-expanded', elm.classList.contains('focus') ? 'true' : 'false');
						closeTouchSubmenus(elm);
					}, { passive:false });
				}
			})

			// tab navigation for the menu

			document.querySelectorAll('.site-nav.style--classic .has-submenu > a').forEach(childEl=>{

				const elm = childEl.parentNode;
				const elmMenu = document.getElementById(childEl.getAttribute('aria-controls'));

				elm.addEventListener('keydown', e=>{

					if ( e.keyCode === window.KEYCODES.RETURN ) {
						if ( ! e.target.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							e.target.setAttribute('aria-expanded', 'true');
							//elmMenu.setAttribute('aria-hidden', 'false');
						} else if ( document.activeElement.parentNode.classList.contains('has-submenu') && elm.classList.contains('focus') ) {
							elm.classList.remove('focus');
							e.target.setAttribute('aria-expanded', 'true');
							//elmMenu.setAttribute('aria-hidden', 'false');
						}
					}
				});	
				
				if ( elm.querySelector('.submenu-holder > li:last-child a') ) {
					elm.querySelector('.submenu-holder > li:last-child a').addEventListener('focusout', e=>{
						if ( elm.classList.contains('focus') ) {
							elm.classList.remove('focus');
							e.target.setAttribute('aria-expanded', 'false');
							//elmMenu.setAttribute('aria-hidden', 'true');
						}
					});
				}

			});

			document.querySelectorAll('.site-nav.style--classic .has-babymenu:not(.mega-link) > a').forEach(childEl=>{	

				const elm = childEl.parentNode;
				const elmMenu = document.getElementById(childEl.dataset.ariaControls);

				elm.addEventListener('keydown', e=>{
					if ( e.keyCode === window.KEYCODES.RETURN ) {
						if ( ! e.target.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							e.target.setAttribute('aria-expanded', 'true');
							//elmMenu.setAttribute('aria-hidden', 'false');
						} else {
							elm.classList.remove('focus');
							e.target.setAttribute('aria-expanded', 'false');
							//elmMenu.setAttribute('aria-hidden', 'true');
						}
					}
				});

				if ( elm.querySelector('.babymenu li:last-child a') ) {
					elm.querySelector('.babymenu li:last-child a').addEventListener('focusout', e=>{
						if ( elm.parentNode.classList.contains('focus') ) {
							elm.parentNode.classList.remove('focus');
							elm.parentNode.setAttribute('aria-expanded', 'false');
						}
					});
				}

			})

		}

		unmount(){
			window.removeEventListener('resize', this.RESIZE_SidebarHelper);
			if ( this.RESIZE_StickyHelper ) {
				window.removeEventListener('resize', this.RESIZE_StickyHelper);
			}
			if ( this.SCROLL_StickyHelper ) {
				window.removeEventListener('scroll', this.SCROLL_StickyHelper);
			}
			if ( this._restoreDesktopHeader ) {
				this._restoreDesktopHeader();
			}
			if ( this._stickyHeaderEl ) {
				this._stickyHeaderEl.remove();
			}
			if ( this._headerSearchQNameSync ) {
				document.body.removeEventListener('input', this._headerSearchQNameSync);
			}
		}

	}
	
  if ( typeof customElements.get('main-header') === 'undefined' ) {
		customElements.define('main-header', MainHeader);
	}

}

if ( typeof SidebarDrawer !== 'function' ) {

	class SidebarDrawer extends HTMLElement {

		constructor(){
			super();
			this._navigationHideTimer = null;
			this.querySelector('[data-js-close]').addEventListener('click', ()=>{
				this.hide();
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode === window.KEYCODES.ESC ) {
					const openedSidebar = document.querySelector('sidebar-drawer.sidebar--opened');
					if ( openedSidebar ){
						openedSidebar.hide();
					}
				}
			});
			if ( this.id === 'site-menu-sidebar' ) {
				this._navigationResizeHandler = () => {
					if ( window.innerWidth >= 1024 && this.opened ) this.hide();
				};
				window.addEventListener('resize', this._navigationResizeHandler, { passive: true });
			}
		}

		_mountSharedNavigation(){
			if ( this.id !== 'site-menu-sidebar' ) return;
			const navigation = document.querySelector('[data-shared-navigation]');
			const target = this.querySelector('#MobileNavTarget');
			const mobileNavigation = this.querySelector('mobile-navigation');
			if ( ! navigation || ! target || ! mobileNavigation || target.contains(navigation) ) return;
			this._sharedNavigationPlaceholder = document.createComment('shared-navigation');
			navigation.before(this._sharedNavigationPlaceholder);
			this._sharedNavigation = navigation;
			const siteNav = navigation.querySelector('.site-nav');
			if ( siteNav ) {
				siteNav.classList.remove('style--classic');
				siteNav.classList.add('style--sidebar');
				siteNav.querySelectorAll('.has-submenu > a, .has-babymenu > a').forEach(link => {
					link.style.pointerEvents = '';
				});
				siteNav.querySelectorAll('.submenu.normal-menu').forEach(menu => {
					menu.style.removeProperty('left');
					menu.style.removeProperty('right');
				});
				siteNav.querySelectorAll('.submenu-masonry').forEach(elm => {
					elm.classList.remove('masonry-active');
					elm.removeAttribute('style');
					elm.querySelectorAll(':scope > .mega-link').forEach(link => link.removeAttribute('style'));
				});
			}
			target.append(navigation);
			mobileNavigation.mountNavigation(navigation);
		}

		_restoreSharedNavigation(){
			if ( ! this._sharedNavigation || ! this._sharedNavigationPlaceholder ) return;
			const mobileNavigation = this.querySelector('mobile-navigation');
			if ( mobileNavigation ) mobileNavigation.resetNavigation();
			const siteNav = this._sharedNavigation.querySelector('.site-nav');
			if ( siteNav ) {
				siteNav.classList.remove('style--sidebar');
				siteNav.classList.add('style--classic');
			}
			this._sharedNavigationPlaceholder.replaceWith(this._sharedNavigation);
			this._sharedNavigationPlaceholder = null;
			this._sharedNavigation = null;
		}

		/* 
			* generic hide/show functions 
		*/

		show(){
			if ( this._navigationHideTimer ) {
				clearTimeout(this._navigationHideTimer);
				this._navigationHideTimer = null;
			}
			this._mountSharedNavigation();

			this.opened = true;
			this.removeAttribute('aria-hidden');
			document.body.classList.add('sidebar-opened');
			if ( this.classList.contains('sidebar--right') ) {
				document.body.classList.add('sidebar-opened--right');
			} else if ( this.classList.contains('sidebar--left') ) {
				document.body.classList.add('sidebar-opened--left');
			}
			this.style.display = 'grid';
			setTimeout(()=>{
				this.classList.add('sidebar--opened');
				window.inertElems.forEach(elm=>{
					elm.setAttribute('inert', '');
				})
			}, 15);
			if ( this.id === "site-cart-sidebar" ) {
				if ( document.querySelector('#cart-recommendations css-slider') ) {
					document.querySelector('#cart-recommendations css-slider').resetSlider();
				}
			}

		}

		hide(){
			if ( this._navigationHideTimer ) clearTimeout(this._navigationHideTimer);

			this.opened = false;
			this.classList.remove('sidebar--opened');

			document.body.classList.remove('sidebar-opened');
			document.body.classList.remove('sidebar-opened--left');
			document.body.classList.remove('sidebar-opened--right');
			window.inertElems.forEach(elm=>{
				elm.removeAttribute('inert');
			})

			document.querySelector(`[aria-controls="${this.id}"]`)?.setAttribute('aria-expanded', 'false');

			this._navigationHideTimer = setTimeout(()=>{
				this.style.display = 'none';
				this._restoreSharedNavigation();
				this._navigationHideTimer = null;
			}, 501);

		}

		disconnectedCallback(){
			if ( this._navigationResizeHandler ) {
				window.removeEventListener('resize', this._navigationResizeHandler);
			}
			if ( this._navigationHideTimer ) clearTimeout(this._navigationHideTimer);
			this._restoreSharedNavigation();
		}

	}


  if ( typeof customElements.get('sidebar-drawer') === 'undefined' ) {
		customElements.define('sidebar-drawer', SidebarDrawer);
	}

}

if ( typeof MobileNavigation !== 'function' ) {
		
	class MobileNavigation extends HTMLElement {

		constructor() {

			super();

			this._openedFirstSubmenu = false;
			this._openedSecondSubmenu = false;

			if ( this.dataset.showHeaderActions === 'true' ) {

				const mobileNavActions = document.createElement('div');
				mobileNavActions.classList = "header-actions flex-buttons";
				mobileNavActions.innerHTML = document.querySelector('[data-js-header-actions]').innerHTML;
				this.prepend(mobileNavActions);

				mobileNavActions.querySelectorAll('[id]').forEach(elm=>{
					elm.id = `${elm.id}-mobile`;
				});
				mobileNavActions.querySelectorAll('[data-modal]').forEach(elm=>{
					elm.addEventListener('keydown', e=>{
						if ( e.keyCode === window.KEYCODES.RETURN ) {
							window.lastFocusedElm = elm;
						}
					})
					elm.addEventListener('click', e=>{
						e.preventDefault();
						if ( document.querySelector('.sidebar--opened') ) {
							document.querySelector('.sidebar--opened').hide();
						}
						if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
							document.getElementById(elm.getAttribute('aria-controls')).show();
						}
					})
				});
				
			}

		}

		mountNavigation(navigation) {

			if ( this._boundNavigation === navigation ) return;
			this._boundNavigation = navigation;

			navigation.querySelectorAll('.has-submenu > a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					if ( ! this.contains(elm) || window.innerWidth >= 1024 ) return;
					const menuItem = elm.parentElement;
					const submenu = menuItem?.querySelector(':scope > .submenu');
					if ( ! submenu || ! submenu.querySelector('a[href]') ) return;
					e.preventDefault();
					if ( ! this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = true;
						this.classList.add('opened-first-submenu');
						this.closest('sidebar-drawer').scrollTo({top: 0});
					}
					menuItem.classList.add('opened');
					elm.setAttribute('aria-expanded', 'true');
					this.#resizeContainer();
				})
			});

			navigation.querySelectorAll('.has-babymenu > a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					if ( ! this.contains(elm) || window.innerWidth >= 1024 ) return;
					const menuItem = elm.parentElement;
					const babymenu = menuItem?.querySelector(':scope > .babymenu');
					if ( ! babymenu || ! babymenu.querySelector('a[href]') ) return;
					e.preventDefault();
					if ( ! this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = true;
						this.classList.add('opened-second-submenu');
						this.closest('sidebar-drawer').scrollTo({top: 0});
					}
					menuItem.classList.add('opened');
					elm.setAttribute('aria-expanded', 'true');
					this.#resizeContainer();
				})
			});

			navigation.querySelectorAll('.submenu-back a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					if ( ! this.contains(elm) || window.innerWidth >= 1024 ) return;
					const openedItem = elm.closest('li.opened');
					const openedTrigger = openedItem?.querySelector(':scope > .menu-link');
					const returningToMainMenu = ! elm.closest('.babymenu');
					if ( ! returningToMainMenu ) {
						this._openedSecondSubmenu = false;
						this.classList.remove('opened-second-submenu');
						this.#resizeContainer();
					} else {
						this._openedSecondSubmenu = false;
						this._openedFirstSubmenu = false;
						this.classList.remove('opened-first-submenu', 'opened-second-submenu');
						this.#resizeContainer(true);
					}
					if ( openedTrigger ) openedTrigger.setAttribute('aria-expanded', 'false');
					if ( returningToMainMenu ) this.#restoreMainMenu();
					this.closest('sidebar-drawer').scrollTo({top: 0});
					setTimeout(()=>{
						openedItem?.classList.remove('opened');
						if ( returningToMainMenu ) this.resetNavigation();
					}, 301);
					e.preventDefault();
				})
			});

		}

		resetNavigation() {
			this._openedFirstSubmenu = false;
			this._openedSecondSubmenu = false;
			this.classList.remove('opened-first-submenu', 'opened-second-submenu');
			this.style.height = 'auto';
			this.#restoreMainMenu();
			this.querySelectorAll('li.opened').forEach(elm => elm.classList.remove('opened'));
			this.querySelectorAll('[aria-expanded="true"]').forEach(elm => elm.setAttribute('aria-expanded', 'false'));
		}

		#restoreMainMenu(){
			const linkList = this.querySelector('.link-list');
			if ( ! linkList ) return;
			linkList.getAnimations().forEach(animation => animation.cancel());
			linkList.style.animation = 'none';
			linkList.style.height = 'auto';
			linkList.style.overflow = 'visible';
			requestAnimationFrame(() => {
				linkList.style.removeProperty('animation');
				linkList.style.removeProperty('height');
				linkList.style.removeProperty('overflow');
			});
		}

		#resizeContainer(main=false){
      if ( main ) {
				this.style.height = `auto`;
      } else {
				if ( this._openedSecondSubmenu ) {
					const babymenu = this.querySelector('.has-babymenu.opened .babymenu');
					if ( babymenu ) this.style.height = `${babymenu.scrollHeight}px`;
				} else if ( this._openedFirstSubmenu ) {
					const submenu = this.querySelector('.has-submenu.opened .submenu');
					if ( submenu ) this.style.height = `${submenu.scrollHeight}px`;
				}  
      }
		}

	}

  if ( typeof customElements.get('mobile-navigation') === 'undefined' ) {
		customElements.define('mobile-navigation', MobileNavigation);
	}

}

if ( typeof ScrollableNavigation !== 'function' ) {

	class ScrollableNavigation extends HTMLElement {

		constructor() {

			super();

			this.linkList = this.querySelector('.link-list');
			this.header = this.parentNode;
			window.addEventListener('resize', debounce(()=>{
				this.#checkNav();
			}, 200));
			this.#checkNav();

			const rtl = document.documentElement.getAttribute('dir') === 'rtl';

			this.parentNode.querySelector('.scrollable-navigation-button--left').addEventListener('click', ()=>{
				this.scroll({
					top: 0,
					left: this.scrollLeft - (rtl ? -100 : 100),
					behavior: 'smooth'
				});
			})
			this.parentNode.querySelector('.scrollable-navigation-button--right').addEventListener('click', ()=>{
				this.scroll({
					top: 0,
					left: this.scrollLeft + (rtl ? -100 : 100),
					behavior: 'smooth'
				});
			})

		}

		#checkNav() {
			if ( this.linkList.scrollWidth > this.offsetWidth ) {
				this.header.classList.add('scrolling-navigation-enabled');
			} else {
				this.header.classList.remove('scrolling-navigation-enabled');
			}
		}
		
	}

  if ( typeof customElements.get('scrollable-navigation') === 'undefined' ) {
		customElements.define('scrollable-navigation', ScrollableNavigation);
	}

}
